"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var escapeRegex_1 = __importDefault(require("../escapeRegex"));
/**
* Get total repeats of the given string
*
* @param string $needle
* @return int
*/
function repeatsOf(string, needle, caseSensitive) {
    if (caseSensitive === void 0) { caseSensitive = true; }
    var flags = 'g';
    if (caseSensitive === false) {
        flags += 'i';
    }
    var regex = new RegExp("(" + escapeRegex_1.default(needle) + ")", flags);
    return string.replace(regex, '').length;
}
exports.default = repeatsOf;
;
//# sourceMappingURL=repeatsOf.js.map